import BaseServer from '@/domain/common/base.server.js';
import useRoomBaseServer from '@/domain/room/roombase.server.js';
import { goodSaasApi } from '@/request/index.js';
import useMsgServer from '@/domain/common/msg.server.js';

/**
 * 问答服务
 * @returns
 */

class GoodServer extends BaseServer {
  constructor() {
    if (typeof GoodServer.instance === 'object') {
      return GoodServer.instance;
    }
    super();

    this.state = {
      // 购买按钮文案，后台支持自定义
      btnBuyText: '购买',

      // 是否显示优惠券
      showCoupon: true,
      enable_direct_view: false
    };

    GoodServer.instance = this;
    this.listenEvents()
    return this;
  }

  // 修改数据
  setState(key, value) {
    this.state[key] = value;
  }

  //监听msgServer通知
  listenEvents() {
    // 自定义消息
    useMsgServer().$onMsg('CUSTOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 商品更新
        case 'goods_update_info':
          this.$emit('goods_update_info', temp);
          break;
        default:
          break;
      }
    });
  }

  // 根据问题id查询索引值
  static _findMsgItemByList(data, question_id) {
    let index = data.findIndex(item => {
      return item.id == question_id;
    });
    return index;
  }

  queryGoodsList(params = {}) {
    return goodSaasApi.queryGoodsList(params).then(res => {
      return res;
    });
  }

  queryGoodsListJson(params = {}) {
    return goodSaasApi.queryGoodsListJson(params).then(res => {
      return res;
    });
  }

  getGoodDetail(params = {}) {
    return goodSaasApi.getGoodDetail(params)
  }

  getPreSaleGoods(params = {}) {
    return goodSaasApi.getPreSaleGoods(params)
  }

  getShopRankList(params = {}) {
    return goodSaasApi.getShopRankList(params)
  }

  getProductsOtherInfo(webinarId) {
    const params = {
      business_uid: useRoomBaseServer().state.watchInitData?.webinar.userinfo.user_id,
      webinar_id: webinarId || useRoomBaseServer().state.watchInitData?.webinar?.id
    }
    return goodSaasApi.getProductsOtherInfo(params).then(res => {
      if (res.code == 200) {
        this.state.btnBuyText = res.data.btn_description;
        this.state.showCoupon = !!res.data['enable_coupon'];
        this.state.enable_direct_view = !!res.data['enable_direct_view'];
      }
      return res;
    });
  }

}

export default function useGoodServer() {
  return new GoodServer();
}
